import { useState } from 'react';
import { ArrowDownIcon } from 'native-base';
import { useTranslation } from 'react-i18next';

import { ButtonGroup, Thermometer02Icon } from '@pimm/base';
import { DoorEventIcon } from '../icons/door-event';

export type FilterEventType = 'all' | 'uptime' | 'data' | 'oos' | 'temp' | 'temp-event' | 'door-event';

type FilterButtonsProps = Pick<React.ComponentProps<typeof ButtonGroup>, 'value' | 'onChange' | 'w' | 'flex'> & {
  isPerformance?: boolean;
};

export const FilterButtons = ({ isPerformance, ...props }: FilterButtonsProps) => {
  const { t } = useTranslation();
  const [tabItems] = useState(() =>
    [
      { title: 'store_equipment:all', value: 'all', isHidden: false },
      {
        title: 'store_equipment:uptime_tab',
        value: 'uptime',
        isHidden: isPerformance,
        startIcon: <ArrowDownIcon size={3} color="gray.700" />,
      },
      { title: 'store_equipment:data', value: 'data', isHidden: isPerformance },
      { title: 'store_equipment:oos_tab', value: 'oos', isHidden: isPerformance },
      {
        title: 'store_equipment:in_temp_tab',
        value: 'temp',
        isHidden: !isPerformance,
        startIcon: <ArrowDownIcon size={3} color="gray.700" />,
      },
      { title: 'store_equipment:event_tab', value: 'temp-event', isHidden: !isPerformance, startIcon: <Thermometer02Icon size={3} /> },
      { title: 'store_equipment:event_tab', value: 'door-event', isHidden: !isPerformance, startIcon: <DoorEventIcon size={3} /> },
    ].filter(segment => !segment.isHidden),
  );

  return (
    <ButtonGroup {...props}>
      {tabItems.map(tabItem => (
        <ButtonGroup.Item
          key={tabItem.value}
          value={tabItem.value}
          startIcon={tabItem.startIcon}
          minWidth={tabItem.value === 'all' ? 50 : 60}
          maxWidth={tabItem.value === 'all' ? 50 : 110}
          flex={1}
        >
          {['uptime', 'data', 'temp'].includes(tabItem.value) ? `${t(tabItem.title)} %` : t(tabItem.title)}
        </ButtonGroup.Item>
      ))}
    </ButtonGroup>
  );
};
